import { Installation } from "../domain/Installation";
import { InstallationsRepository } from "../domain/InstallationsRepository";
import { sync_command_dispatcher, query_dispatcher } from "@/api/client";

export class APIInstallationsRepository implements InstallationsRepository {
    
    async find_by_id(uuid: string): Promise<Installation[]> {
        throw new Error("Method not implemented.");
    }
    
    async find_by_user_id(id: number): Promise<Installation[]> {
        return await query_dispatcher.dispatch('get.installations.query', { user_id: id })
    }
    
    async create(ins: Installation, payment_path: string) {
        return await sync_command_dispatcher.dispatch(
            'create.installation',
            { installation: ins.toPrimitive(), payment_path: payment_path }
        );
    }
    
}